/**
 * Intégration HubSpot
 * Renseigne automatiquement le champ caché "source__c" des formulaires HubSpot.
 */
(function () {
  var value = "site ECLA";

  function setSourceInForms() {
    document.querySelectorAll('[data-hs-forms-root] form, .hbspt-form form').forEach(function (form) {
      var input = form.querySelector('input[name="source__c"]');
      if (input) input.value = value;
    });
  }

  window.addEventListener('hs-form-event:on-ready', function () {
    setSourceInForms();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setSourceInForms);
  } else {
    setSourceInForms();
  }

  var attempts = 0;
  var tid = setInterval(function () {
    setSourceInForms();
    if (++attempts >= 15) clearInterval(tid);
  }, 400);
})();
